export var main_btn_regularLogin = {
    key: 'sign_in::main_btn_regularLogin',
    fallback: "Log In"
};
export var main_btn_sso = {
    key: 'sign_in::main_btn_sso',
    fallback: "Single Sign-on"
};
export var main_lbl_forgotPassword = {
    key: 'sign_in::main_lbl_forgotPassword',
    fallback: "Forgot password"
};
export var main_lbl_register = {
    key: 'sign_in::main_lbl_register',
    fallback: "New to PaymentsOS? Sign Up"
};
export var main_lbl_ssoDescription = {
    key: 'sign_in::main_lbl_ssoDescription',
    fallback: "No password needed. We will log you in using your SSO credentials."
};
export var main_title_logIn = {
    key: 'sign_in::main_title_logIn',
    fallback: "Log in to PaymentsOS"
};
export var main_title_welcomeBack = {
    key: 'sign_in::main_title_welcomeBack',
    fallback: "Welcome back!"
};
export var main_toolTip_sso = {
    key: 'sign_in::main_toolTip_sso',
    fallback: "This is the username and password that you use to\naccess other applications and tools in your\norganization."
};
